import { render, staticRenderFns } from "./HoldConversionsTable.vue?vue&type=template&id=37b67f22&scoped=true&"
import script from "./HoldConversionsTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HoldConversionsTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HoldConversionsTable.vue?vue&type=style&index=0&id=37b67f22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b67f22",
  null
  
)

export default component.exports